import { zaokr } from "../../../../functions/utilities";

const MieszkaniecDaneWodaRozliczenieWydrukStan = props => {
    
    const { procent, odczyty } = props;    
    // console.log(odczyty)
    return (
        <section style={{marginBottom: "30px", display: "flex", justifyContent: "center"}}>
            <table style={{fontSize: "0.7rem"}}>
                <tbody>
                    <tr>
                        <td rowSpan={2}>

                        </td>
                        <td colSpan={3} style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                            {`Stan liczników wody (w m³)`}
                        </td>
                    </tr>            
                    <tr>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                            Stan początkowy
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                            Stan bieżący
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px", fontWeight: "600"}}>
                            Zużycie
                        </td>
                    </tr>
                    <tr>
                        <td>
                            zimna woda
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                            {odczyty?.zimna_stan_poczatek}
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                            {odczyty?.zimna_stan_koniec}
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                            {zaokr(procent?.zuzycieMieszkancaZimna)}</td>
                    </tr>
                    <tr>
                        <td>
                            ciepła woda
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                            {odczyty?.ciepla_stan_poczatek}
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                            {odczyty?.ciepla_stan_koniec}
                        </td>
                        <td style={{border: "1px solid black", textAlign: "center", padding: "5px 10px"}}>
                            {procent?.zuzycieMieszkancaCiepla}
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukStan;